import { render, staticRenderFns } from "./item-category-with-personnels.vue?vue&type=template&id=066b1013&"
import script from "./item-category-with-personnels.vue?vue&type=script&lang=js&"
export * from "./item-category-with-personnels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports